import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import EventReservationForm from './forms/EventReservationForm';
import EventReservationList from './lists/EventReservationList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import ModalEditor from "./ModalEditor";
import InvoiceEditor from "./invoiceEditor";
import {postData} from "../../utils/request";
import connect from "react-redux/es/connect/connect";
import {showModal} from "../../actions";

class EventReservationEditor extends React.Component {

    state = {
        listType: 'calendar',
        moneyrepository: null,
        participant_qty: 0,
        price: 0,
        loading: false
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (this.props.values[this.props.componentConfig.idfield]) {
            if (this.state.participant_qty + "" !== "" + prevState.participant_qty) {
                this.priceRequest && this.priceRequest.abort();
                this.setState({loading: true}, () => {
                    this.priceRequest = postData({
                        action: this.props.componentConfig.componentname + '.calculateParticipantPrice',
                        [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                        participant_qty: this.state.participant_qty,
                        moneyrepository: this.state.moneyrepository
                    });
                    this.priceRequest.then(({price}) => {
                        this.setState({price, loading: false});
                    });
                    this.priceRequest.catch(() => {
                        this.setState({loading: false});
                    })
                });
            }
        } else {
            if (this.state.price !== 0 || this.state.loading !== false) {
                this.setState({price: 0, loading: false});
            }
        }
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    getFieldProps = (name) => {
        const props = this.props.getFieldProps(name);
        props.disabled = props.disabled || props.pos !== undefined || (this.props.values || {}).state + "" === "3";
        return props;
    }

    updateParticipants = async () => {
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.updateParticipants',
                [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                participant_qty: this.state.participant_qty,
                moneyrepository: this.state.moneyrepository
            });
            if (response.success) {
                this.setState({
                    moneyrepository: null,
                    participant_qty: 0
                });
                this.props.showModal({
                    size: "small",
                    theme: "success",
                    header: "Sikeres művelet",
                    text: "Sikeres hozzáadás!",
                    timeout: 1500
                });
            }
            return response;
        });
    }

    render() {
        const ListBox = this.props.list || Box;
        const EditorBox = this.props.editor || BoxEditor;

        const buttons = [];
        const actionButtons = [];

        const props = {...this.props};
        props.filter = Array.isArray(props.filter) ? [...props.filter] : (props.filter !== null && props.filter !== undefined ? [props.filter] : []);
        if(props.pos !== undefined) {
            props.filter = [
                ...props.filter, ...[
                    {
                        field: "event.locations.left",
                        value: props.pos.location.left,
                        operator: ">"
                    },
                    {
                        field: "event.locations.right",
                        value: props.pos.location.right,
                        operator: "<"
                    },
                    {
                        field: "event.locations.partner",
                        value: props.pos.partner.partner_id
                    }
                ]
            ];
        }

        actionButtons.push(
            <Button
                key="0"
                disabled={!props.dirty || props.isLoading}
                color="primary"
                className="pull-right"
                onClick={this.saveForm}
            >
                Mentés
            </Button>
        );

        if (props.pos === undefined) {
            actionButtons.push(
                <Button
                    key="1"
                    disabled={!props.values[props.componentConfig.idfield] || this.props.values.state + "" === "3" || this.props.isLoading}
                    color="danger"
                    className="pull-left"
                    onClick={props.deleteForm}
                >
                    Törlés
                </Button>
            );
            buttons.push(
                <Button
                    key="0"
                    disabled={props.isLoading}
                    color="default"
                    onClick={this.pristineForm}
                >
                    Új
                </Button>
            );
        }

        return (
            <Fragment>
                <ListBox
                    {...props}
                    theme="default"
                    header={"Foglalások"}
                    footer={props.pos === undefined && buttons}
                >
                    <EventReservationList
                        ref={(el) => this.list = el}
                        {...props}
                        loadForm={this.loadForm}
                    />
                </ListBox>
                <EditorBox
                    {...props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Foglalás"}
                    footer={actionButtons}
                >
                    <EventReservationForm
                        ref={(form) => this.form = form}
                        {...props}
                        getFieldProps={this.getFieldProps}
                        setMoneyRepository={(moneyrepository) => this.setState({moneyrepository})}
                        setParticipantQty={(participant_qty) => this.setState({participant_qty: participant_qty || 0})}
                        moneyrepository={this.state.moneyrepository}
                        participant_qty={this.state.participant_qty}
                        priceLoading={this.state.loading}
                        price={this.state.price}
                        updateParticipants={this.updateParticipants}
                    />
                </EditorBox>
                {
                    props.pos === undefined && props.values[props.componentConfig.idfield]
                    &&
                    <InvoiceEditor
                        pageSize={0}
                        listFilter={[
                            {
                                field: "component",
                                value: props.componentConfig.componentname
                            },{
                                field: "component_id",
                                value: props.values[props.componentConfig.idfield]
                            }
                        ]}
                        editor={ModalEditor}
                        selection={null}
                    />
                }
            </Fragment>
        );
    }
}

export default connect(() => ({}),{showModal})(createEditor({
    componentName: "EventReservation",
    WrappedComponent: EventReservationEditor,
    props: {
        componentActions: (action, data, params) => {
            params.notExecutePayment = true;
            return {action,data,params};
        }
    }
}));
